export const UiColors = [
  'primary', // green
  'secondary', // gray
  'pink',
  'red', // error
  'orange', // danger
  'yellow', // warning
  'green',
  'teal', // success
  'cyan',
  'blue', // info
  'indigo',
  'purple' // help
];
export const UiSizes = ['x-small', 'small', 'default', 'large', 'x-large'];
export const Ui3Sizes = ['small', 'default', 'large'];

export const viewTypeOptions = [
  {
    value: 'list',
    icon: 'pi pi-list'
  },
  {
    value: 'grid',
    icon: 'pi pi-th-large'
  }
];

export const paginatorOptions = [10, 20, 30];

export const stateRole = {
  lksam : {
    value: 'lksam',
    label: 'Lksam',
    class: 'primary',
    color: 'green'
  }, 
  partner : {
    value: 'partner',
    label: 'Partner',
    class: 'help',
    color: 'purple'
  },
  client : {
    value: 'client',
    label: 'Client',
    class: 'info',
    color: 'purple'
  },
  site : {
    value: 'site',
    label: 'Site',
    class: 'secondary',
    color: 'gray'
  }
};

export const stateUserRole = {
  admin: {
    value: 'admin',
    label: 'admin',
    class: 'bg-red-600 text-white', // 강한 레드
    color: 'red'
  },
  user: {
    value: 'user',
    label: 'user',
    class: 'bg-indigo-600 text-white', // 짙은 인디고
    color: 'indigo'
  }
};

export const cameraState = {
  Connect: {
    class: 'primary',
    label: '사용중',
  },
  Disconnect: {
    class: 'secondary',
    label: '미사용중',
  },
  Error: {
    class: 'error',
    label: '에러',
  },
};

// 사용중(Connect) 상태일 때 client_type 별 표시 색상
export const cameraClientTypeState = {
    FDS: {
        class: 'primary',
        label: 'FDS'
    },
    EDGE: {
        class: 'cyan',
        label: 'EDGE'
    },
    EWD: {
        class: 'pink',
        label: 'EWD'
    }
};

export const temperatureState = {
  high: {
    textClass: 'text-pink-400',
    label: '최고 온도',
  },
  average: {
    textClass: 'text-green-400',
    label: '평균 온도'
  },
  low: {
    textClass: 'text-cyan-400',
    label: '최저 온도'
  }
}

export const alertState = {
  error: {
    class: 'secondary',
    color: 'gray',
    label: '연결오류',
  },
  Alert1: {
    class: 'warning',
    color: 'yellow',
    label: 'Alert1',
  },
  Alert2: {
    class: 'danger',
    color: 'orange',
    label: 'Alert2',
  },
  Alert3: {
    class: 'error',
    color: 'red',
    label: 'Alert3',
  }
}